import instance from "../../utils/axios";

export const getNumberBySiteCode = async (data) => {
    return await instance.post('/numbers/getNumberBySiteCode', data)
  };
  